import { z } from "zod";

export enum ESubscriberSearchField {
  EMAIL = "email",
  FIRSTNAME = "subscriberFirstname",
  LASTNAME = "subscriberLastname",
  ID = "subscriberId",
  PHONE = "phone",
}

export enum ESubscriberSearchInputType {
  NUMBER = "NUMBER",
  STRING = "STRING",
}

export const ESubscriberSearchFieldInputType: Record<ESubscriberSearchField, ESubscriberSearchInputType> = {
  [ESubscriberSearchField.ID]: ESubscriberSearchInputType.NUMBER,
  [ESubscriberSearchField.LASTNAME]: ESubscriberSearchInputType.STRING,
  [ESubscriberSearchField.FIRSTNAME]: ESubscriberSearchInputType.STRING,
  [ESubscriberSearchField.EMAIL]: ESubscriberSearchInputType.STRING,
  [ESubscriberSearchField.PHONE]: ESubscriberSearchInputType.STRING,
};

export enum ESubscriberSearchFilterType {
  EQUALS = "EQUALS",
  CONTAINS = "CONTAINS",
  STARTS_BY = "STARTS_BY",
  ENDS_BY = "ENDS_BY",
}

export const subscriberSearchFieldSchema = z.nativeEnum(ESubscriberSearchField);
export const subscriberSearchFilterTypeSchema = z.nativeEnum(ESubscriberSearchFilterType);
export const subscriberSearchInputTypeSchema = z.nativeEnum(ESubscriberSearchInputType);
